import { render, staticRenderFns } from "./DialogFolderSelector.vue?vue&type=template&id=4ca119ae"
import script from "./DialogFolderSelector.vue?vue&type=script&lang=js"
export * from "./DialogFolderSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports